"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import classnames from "classnames";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { useUploadCV } from "@/react-query/mutations";
import Button from "@/components/Button";
import ProgressIndicator from "@/components/ProgressIndicator";
import UploadCV from "@/layout/UploadCV";
import cloud from "../../../public/svgs/cloud.svg";
import styles from "./styles.module.scss";
import { localStore, SessionStorageEnum, sessionStore } from "@/utils/storage";
import { privateRoutes } from "@/routes";
import { useAccountStore } from "@/stores";
export const sizeError = "Dateigröße überschritten. Die maximal zulässige Dateigröße beträgt 3 MB.";
function Complete() {
  const $ = _c(58);
  const {
    t
  } = useTranslation();
  const router = useRouter();
  const {
    accountDetails
  } = useAccountStore();
  const [file, setFile] = React.useState(null);
  const [fileSelected, setFileSelected] = React.useState(false);
  const [error, setError] = React.useState("");
  const {
    isSuccess,
    data,
    mutateAsync
  } = useUploadCV();
  let t0;
  if ($[0] !== mutateAsync || $[1] !== t) {
    t0 = async file_0 => {
      setFile(file_0);
      setError("");
      ;
      try {
        if (file_0) {
          await mutateAsync(file_0);
        }
      } catch (t1) {
        const error_0 = t1;
        if (error_0 instanceof Error && error_0.message.indexOf("3 MB") > -1) {
          setError(t(sizeError) as string);
        } else {
          setError(t("Es ist ein Fehler aufgetreten, bitte laden Sie die Seite neu.") as string);
        }
      }
    };
    $[0] = mutateAsync;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleFile = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  React.useEffect(_temp, t1);
  let t2;
  let t3;
  if ($[4] !== error) {
    t2 = () => {
      if (error) {
        setFile(null);
        setFileSelected(false);
      }
    };
    t3 = [error];
    $[4] = error;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  React.useEffect(t2, t3);
  let t4;
  let t5;
  if ($[7] !== data || $[8] !== isSuccess || $[9] !== router) {
    t4 = () => {
      if (isSuccess) {
        const {
          stringifyId,
          stringifyFileSize,
          fileName,
          identifier
        } = data;
        setTimeout(() => {
          router.push(privateRoutes.upload.root.replace(":uploadId", stringifyId).replace(":token", identifier).replace(":fileName", encodeURIComponent(fileName)).replace(":fileSize", stringifyFileSize));
        }, 1000);
      }
    };
    t5 = [data, isSuccess, router];
    $[7] = data;
    $[8] = isSuccess;
    $[9] = router;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  React.useEffect(t4, t5);
  let t6;
  if ($[12] !== accountDetails.email || $[13] !== router.query) {
    t6 = () => {
      if (accountDetails.email && router.query.redirect_to) {
        sessionStore.setItem(SessionStorageEnum.jobIndexParameters, {
          email: accountDetails.email,
          job_id: router.query.job_id as string,
          redirect_to: router.query.redirect_to as string,
          account_id: router.query.account_id as string
        });
      }
    };
    $[12] = accountDetails.email;
    $[13] = router.query;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = router.query?.account_id;
  const t8 = router.query?.job_id;
  const t9 = router.query?.redirect_to;
  let t10;
  if ($[15] !== accountDetails.email || $[16] !== t7 || $[17] !== t8 || $[18] !== t9) {
    t10 = [accountDetails.email, t7, t8, t9];
    $[15] = accountDetails.email;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  React.useEffect(t6, t10);
  let t11;
  if ($[20] !== fileSelected) {
    t11 = classnames(styles.uploadMenu, {
      [styles.disappear]: fileSelected
    });
    $[20] = fileSelected;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const uploadMenuClass = t11;
  let t12;
  if ($[22] !== isSuccess) {
    t12 = classnames(styles.uploadProgress, "max-w-sm mx-auto w-full", {
      [styles.hideBar]: isSuccess
    });
    $[22] = isSuccess;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const progressClass = t12;
  let t13;
  if ($[24] !== fileSelected) {
    t13 = classnames({
      [styles.hide]: fileSelected
    });
    $[24] = fileSelected;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  const uploadButtonTextClass = t13;
  let t14;
  if ($[26] !== fileSelected) {
    t14 = classnames(styles.formats, {
      [styles.hide]: fileSelected
    });
    $[26] = fileSelected;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  const formatsClass = t14;
  let t15;
  if ($[28] !== fileSelected) {
    t15 = classnames(styles.errorText, {
      [styles.hide]: fileSelected
    });
    $[28] = fileSelected;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  const errorClass = t15;
  let t16;
  if ($[30] !== file || $[31] !== isSuccess || $[32] !== progressClass) {
    t16 = file && <ProgressIndicator isSuccess={isSuccess} duration={5000} className={progressClass} />;
    $[30] = file;
    $[31] = isSuccess;
    $[32] = progressClass;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== handleFile) {
    t17 = files => {
      const file_1 = files?.item(0);
      if (file_1) {
        setFileSelected(true);
        setTimeout(() => handleFile(file_1), 500);
      }
    };
    $[34] = handleFile;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t) {
    t18 = t("Lebenslauf hochladen");
    $[36] = t;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t17 || $[39] !== t18 || $[40] !== uploadButtonTextClass) {
    t19 = <Button onChange={t17} type="file" className={uploadButtonTextClass} icon={cloud} accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document">{t18}</Button>;
    $[38] = t17;
    $[39] = t18;
    $[40] = uploadButtonTextClass;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t) {
    t20 = t("PDF oder DOCX, max. 3 MB");
    $[42] = t;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== formatsClass || $[45] !== t20) {
    t21 = <p className={formatsClass}>{t20}</p>;
    $[44] = formatsClass;
    $[45] = t20;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== error || $[48] !== errorClass) {
    t22 = !!error && <p className={errorClass}>{error}</p>;
    $[47] = error;
    $[48] = errorClass;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== t19 || $[51] !== t21 || $[52] !== t22 || $[53] !== uploadMenuClass) {
    t23 = <div className={uploadMenuClass}>{t19}{t21}{" "}{t22}</div>;
    $[50] = t19;
    $[51] = t21;
    $[52] = t22;
    $[53] = uploadMenuClass;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  if ($[55] !== t16 || $[56] !== t23) {
    t24 = <div className={styles.uploadContainer}>{t16}{t23}</div>;
    $[55] = t16;
    $[56] = t23;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  return t24;
}
function _temp() {
  localStore.removeItem("hasSeenSaveModal");
}
export default Complete;
Complete.getLayout = function getLayout(page: React.ReactElement) {
  return <UploadCV>{page}</UploadCV>;
};